import { events } from "../../../scripts/constants";
import { toggleState } from "../../../scripts/utility/toggleState";
import { addEventToElements, EventEmitter, postJsonWithResponse, trackEvent } from "../../../utils";
import { initAddToBasketV2, updateDropdownsFromServer, updateItemInBasket } from "../basket-v2";
import { constants } from "../common";
import { hideBasketNotificationBar } from "./hideBasketNotificationBar";

const { basketNotificationBar } = constants.selectors;
const { basketAlertTimeout } = constants.defaults;

export let notificationBarTimeout: number | undefined;
export const basketNotificationElement = document.querySelector(basketNotificationBar);

export async function showBasketNotificationBar({
  delay,
  basketUrl,
  products
}: BasketNotificationBasketBarOptions) {
  let basketContentElement = basketNotificationElement.querySelector<HTMLElement>("[data-product-id]");
  let parentProductId = 0;

  if (basketContentElement) {
    parentProductId = parseInt(basketContentElement.dataset.productId);
  }

  const response = await postJsonWithResponse(constants.urls.basketV2.notification_bar, {
    basketUrl: basketUrl,
    products: products,    
    parentProductId: parentProductId,    
  });

  basketNotificationElement.innerHTML = await response.text();
  basketNotificationElement.classList.add("active");


  bindEvents({ delay, basketUrl, products});
  configureTimeout(delay);

  //refresh
  basketContentElement = basketNotificationElement.querySelector<HTMLElement>("[data-product-id]");

  await updateDropdownsFromServer(basketContentElement);
}

function bindEvents({ delay, basketUrl, products }: BasketNotificationBasketBarOptions) {
  initAddToBasketV2();

  basketNotificationElement.addEventListener("mouseover", () => {
    if (notificationBarTimeout) {
      clearTimeout(notificationBarTimeout);
    }
  });

  basketNotificationElement.addEventListener("mouseout", () => {
    if (!notificationBarTimeout) {
      configureTimeout(delay);
    }
  });

  toggleState("[data-toggle-ticket]", "toggleTicket", "active");

  var closeButton = basketNotificationElement.querySelector<HTMLElement>(".close-quick-view");

  if (closeButton) {
    closeButton.addEventListener("click", () => {
      hideBasketNotificationBar();
      trackEvent({
        event: "basket-notification",
        category: "Basket Notification Bar",
        action: "Close",
        label: "",
      });
    });
  }

  addEventToElements(`${constants.selectors.basketNotificationBar} .qty.trigger`, "change", (e) => {
    hideBasketNotificationBar();
    updateItemInBasket(
      e.target as HTMLSelectElement,
      async () => await showBasketNotificationBar({ delay, basketUrl, products })
    );
  });

  //hide basket is clicked outside of the notification bar
  addEventToElements("body", "click", (e) => {
    if (!basketNotificationElement.contains(e.target as Node)) {
      hideBasketNotificationBar();
    }
  });

  var viewBasketButton = basketNotificationElement.querySelector<HTMLElement>("[data-view-basket]");

  if (viewBasketButton) {
    trackEvent({
      event: "basket-notification",
      category: "Basket Notification Bar",
      action: "View Basket",
      label: "",
    });
  }

  trackEvent({
    event: "basket-notification",
    category: "Basket Notification Bar",
    action: "Open",
    label: "",
  });
}

function configureTimeout(delay: number | "none") {
  //hide alert box after 5 seconds unless told otherwise by the options
  let timeout: number | undefined = basketAlertTimeout;

  if (delay === "none") {
    timeout = null;
  } else if (delay >= 0) {
    timeout = delay;
  }

  if (!!timeout && timeout >= 0) {
    if (notificationBarTimeout && notificationBarTimeout !== timeout) {
      clearTimeout(notificationBarTimeout);
    }
    notificationBarTimeout = setTimeout(
      () => {
        hideBasketNotificationBar();
      },
      timeout,
      null
    );
  }
}

export type BasketNotificationBasketBarOptions = {
  delay?: number | "none";
  products?: BasketNotificationBasketBarProductOptions[];    
  basketUrl?: string;
  onClosed?: () => void;
};

export type BasketNotificationBasketBarProductOptions = {
  productId?: number;
  zoneId?: number;
  eventId?: number;
}

EventEmitter.on(events.BASKET_NOTIFICATION, showBasketNotificationBar);
